<ng-content select=".input-group-prepend"></ng-content>
<input [ngModel]="filterTerm"
       (input)="onInput($event.target.value)" [disabled]="disabled"
       [placeholder]="placeholder" [id]="id"
       [attr.type]="'text'" autocomplete="off" class="form-control rounded-end" (focus)="onFocus()"/>
@if (!filterTerm) {
  <span class="input-group-text border-0 search-icon bg-transparent">
    <span class="fa-light fa-search"></span>
  </span>
}
@if (filterTerm && !searching) {
  <button class="input-group-text border-0 reset-icon bg-transparent" (click)="reset()">
    <span class="fa-light fa-xmark-large"></span>
  </button>
}
@if (showTooltip) {
  <span class="input-group-text border-0 info-icon bg-transparent">
    <app-tooltip>
      <span class="fa fa-info-circle"></span>
      <span class="tooltipContent">
        <ul>
          <li>Put your search term between quotation marks to find an exact match ("search term")</li>
          <li>Use multiple words with spaces to match items containing all search terms (Algeciras AMAZONEH)</li>
          <li>Use OR to match items containing one or more search terms (Algeciras OR Barcelona)</li>
        </ul>
      </span>
    </app-tooltip>
  </span>
}
@if (searching) {
  <span class="input-group-text border-0 search-icon bg-transparent">
    <span class="spinner-border spinner-border-sm text-secondary" role="status"></span>
  </span>
}
<ng-content select=".invalid-feedback"></ng-content>
<ng-content select=".valid-feedback"></ng-content>
